/* eslint-disable radix */

import { generateRandomString } from 'utils/helpers';
import { AccountingType } from 'v2-types/order';

const generateGenericAccounting = (size:number, startNumber:number, letter:string) :AccountingType[] => Array.from(Array(size).keys()).map((_, index) => ({
  _id: generateRandomString(10),
  amount: 0,
  amount_calculated: 0,
  amount_override: 0,
  code: 'charge',
  kind: 'manual',
  letter,
  number: startNumber + index,
  description: '',
  involved_parties: [],
  entry_date: '',
  months: null,
  per_month: null,
}));

const fillCharges = (acc:AccountingType[], from:number, to:number, size:number, letter:string) => {
  const filteredAccounting = acc?.filter((a) => a.letter?.includes(letter));
  const numbersToInclude = Array.from({ length: (to - from) / 1 }, (value, index) => from + index * 1);
  const filteredCharges = filteredAccounting.filter((f) => numbersToInclude.some((s) => parseInt(f.number as unknown as string) === s));
  if (filteredCharges.length < size) {
    return [
      ...generateGenericAccounting(size, from, letter).map((genericChharge) => {
        const findedCharge = filteredCharges.find((charge) => parseInt(charge.number as unknown as string) === genericChharge.number);
        if (findedCharge) {
          return findedCharge;
        }
        return genericChharge;
	  })
    ];
  }
  return filteredCharges;
};
export const formatDataKM = (accountingData: AccountingType[]) => accountingData.map((f) => ({
  id: f._id,
  description: f.description,
  chargeData: f,
  number: f.number
}));

export const mockData = (accounting:AccountingType[]) => ({
  ldues: formatDataKM(fillCharges(accounting, 1, 6, 5, 'L')),
  lotherCredits: formatDataKM(fillCharges(accounting, 6, 8, 2, 'L')),
  lAdjustments: formatDataKM(fillCharges(accounting, 8, 12, 4, 'L')),
  lAdjustmentsItems: formatDataKM(fillCharges(accounting, 12, 18, 6, 'L')),
  ndues: formatDataKM(fillCharges(accounting, 1, 14, 13, 'N')),
  nadjustments: formatDataKM(fillCharges(accounting, 14, 20, 6, 'N')),
  laddendums: formatDataKM(accounting.filter((f) => f.letter?.includes('L') && f.number === null && f.kind === 'manual')),
  naddendums: formatDataKM(accounting.filter((f) => f.letter?.includes('N') && f.number === null && f.kind === 'manual'))
});
